import React from 'react';
import styled, { keyframes } from 'styled-components';

const load8 = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

const Loader = styled.div`
    border-radius: 50%;
    width: 10em;
    height: 10em;

    &:after {
        border-radius: 50%;
        width: 10em;
        height: 10em;
    }

    margin: 60px auto;
    font-size: 10px;
    position: relative;
    text-indent: -9999em;
    border-top: 1.1em solid rgba(255, 255, 255, 0.2);
    border-right: 1.1em solid rgba(255, 255, 255, 0.2);
    border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
    border-left: 1.1em solid #CC3E2B;
    transform: translateZ(0);

    animation: ${load8} 1.1s infinite linear;
    }
`;

const SmallLoader = styled.div`
    border-radius: 50%;
    width: 3em;
    height: 3em;

    &:after {
        border-radius: 50%;
        width: 10em;
        height: 10em;
    }

    margin: 60px auto;
    font-size: 7px;
    position: relative;
    text-indent: -9999em;
    border-top: 1em solid rgba(255, 255, 255, 0.2);
    border-right: 1em solid rgba(255, 255, 255, 0.2);
    border-bottom: 1em solid rgba(255, 255, 255, 0.2);
    border-left: 1em solid rgba(255, 255, 255, 0.4);
    transform: translateZ(0);

    animation: ${load8} 1.1s infinite linear;
    }
`;

const Wrapper = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
`;

export default ({ type }) => {
    const LoaderComponent = type === 'small' ? SmallLoader : Loader;
    return (
        <Wrapper>
            <LoaderComponent />
        </Wrapper>
    );
};



// WEBPACK FOOTER //
// ./src/components/Loader.js